import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/users')({
	beforeLoad: ({ context: { isAdmin, isLimitedAdmin } }) => {
		if (!isAdmin && !isLimitedAdmin) throw redirect({ to: '/' })
	},
})
